import { createWsActions, WsPrefixes, send } from '@skynet/data-ws-core';
import type { WsCommand } from '@skynet/data-ws-core';

export const prefix = WsPrefixes.esPrefix;

const esActions = createWsActions(prefix);

export const {
  actionConnect: actionEsConnect,
  actionOnOpen: actionEsOnOpen,
  actionDisconnect: actionEsDisconnect,
  actionOnClose: actionEsOnClose,
  actionOnClosed: actionEsOnClosed,
  actionSend: actionEsSend,
  actionOnMessage: actionEsOnMessage,
  actionOnBroken: actionEsOnBroken,
  actionOnReconnectBegin: actionEsOnReconnectBegin,
  actionOnReconnectAttempt: actionEsOnReconnectAttempt,
  actionOnReconnected: actionEsOnReconnected,
  actionOnError: actionEsOnError,
} = esActions;

export { esActions };

/** Dispatches a WS send action with the ES prefix. */
export const wsEsSend = (message: WsCommand) => send(message, prefix);
